import { SET_SELECTED_EQUIPMENT } from 'actions';

export function setSelectedEquipment(selectedEquipment: Array<string>) {
  return { selectedEquipment, type: SET_SELECTED_EQUIPMENT };
}
